import { SEARCH_ENGINES } from '~/utils/navigationContext';

export const DEFAULT_SOURCE_MEDIUM = '(direct) / (none)';

const DIRECT_PARTS = { medium: '(none)', source: '(direct)' };

export type SourceMediumParts = {
  medium: string;
  source: string;
};

function fromUtmParams(utmSource?: string, utmMedium?: string): string | null {
  if (!utmSource && !utmMedium) return null;

  const source = utmSource?.toLowerCase() ?? '(not set)';
  const medium = utmMedium?.toLowerCase() ?? '(not set)';

  return `${source} / ${medium}`;
}

export function deriveReferrerParts(
  referrer: string,
  currentHostname: string
): SourceMediumParts {
  if (!referrer) return DIRECT_PARTS;

  try {
    const hostname = new URL(referrer).hostname.toLowerCase();
    const stripWww = (h: string) => h.replace(/^www\./, '');

    if (stripWww(hostname) === stripWww(currentHostname)) return DIRECT_PARTS;

    const engine = SEARCH_ENGINES.find((e) => hostname.includes(e));
    if (engine) return { medium: 'organic', source: engine };

    return { medium: 'referral', source: stripWww(hostname) };
  } catch {
    return DIRECT_PARTS;
  }
}

function fromReferrer(referrer: string, currentHostname: string): string {
  const { source, medium } = deriveReferrerParts(referrer, currentHostname);

  return `${source} / ${medium}`;
}

function fromSearchParams(search: string): string | null {
  const params = new URLSearchParams(search);
  const utmSource = params.get('utm_source') ?? undefined;
  const utmMedium = params.get('utm_medium') ?? undefined;

  return fromUtmParams(utmSource, utmMedium);
}

export function deriveSourceMedium(
  search: string,
  referrer: string,
  currentHostname: string
): string {
  return fromSearchParams(search) ?? fromReferrer(referrer, currentHostname);
}
